import { Link } from 'react-router-dom';
import {
  Droplets,
  Printer,
  Thermometer,
  AlertTriangle,
  Wind,
  Wrench,
  Layers
} from 'lucide-react';

const quickFixes = [
  { id: 'white-not-printing', label: 'White Not Printing', icon: Droplets, tone: 'bg-gray-200/10 text-gray-200 border-gray-400/30' },
  { id: 'banding-horizontal', label: 'Banding / Lines', icon: Printer, tone: 'bg-blue-400/10 text-blue-200 border-blue-400/30' },
  { id: 'transfer-peeling', label: 'Transfer Peeling', icon: Thermometer, tone: 'bg-orange-400/10 text-orange-200 border-orange-400/30' },
  { id: 'head-strike', label: 'Head Strike / Smear', icon: AlertTriangle, tone: 'bg-red-400/10 text-red-200 border-red-400/30' },
  { id: 'ink-starvation', label: 'Ink Starvation', icon: Wrench, tone: 'bg-yellow-400/10 text-yellow-100 border-yellow-400/30' },
  { id: 'powder-not-sticking', label: 'Powder Not Sticking', icon: Layers, tone: 'bg-green-400/10 text-green-100 border-green-400/30' },
  { id: 'overspray', label: 'Overspray / Fuzzy Edges', icon: Wind, tone: 'bg-cyan-400/10 text-cyan-100 border-cyan-400/30' }
];

export function TapMode() {
  return (
    <div className="min-h-screen bg-dtf-dark">
      <div className="px-4 py-6 max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-white">DTF Wizard</h1>
            <p className="text-sm text-dtf-text-muted">Tap Mode • Fast fixes for XP600 & i3200</p>
          </div>
          <Link
            to="/"
            className="text-sm text-dtf-accent hover:underline"
          >
            Full App
          </Link>
        </div>

        <div className="bg-dtf-panel border border-dtf-border rounded-2xl p-4 mb-6">
          <p className="text-dtf-text text-sm">
            Pick what you’re seeing on the film right now. You’ll get the fastest, safest fix steps first.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {quickFixes.map((q) => {
            const Icon = q.icon;
            return (
              <Link
                key={q.id}
                to={`/issues/${q.id}`}
                className={`flex items-center gap-3 rounded-2xl border p-4 transition-all hover:scale-[1.01] ${q.tone}`}
              >
                <div className="w-11 h-11 rounded-xl bg-dtf-dark/60 border border-dtf-border flex items-center justify-center">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold">{q.label}</div>
                  <div className="text-xs opacity-80">Tap for step-by-step</div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3">
          <Link
            to="/diagnosis"
            className="bg-dtf-accent text-dtf-dark font-semibold rounded-2xl px-4 py-4 text-center"
          >
            Guided Diagnosis
          </Link>
          <Link
            to="/maintenance"
            className="bg-dtf-panel border border-dtf-border text-white font-semibold rounded-2xl px-4 py-4 text-center"
          >
            Maintenance
          </Link>
        </div>

        <div className="mt-6 text-center text-xs text-dtf-text-muted">
          Apex Designs LLC • Built for shop-floor use
        </div>
      </div>
    </div>
  );
}
